import styled from 'styled-components';

export const Container = styled.div`
  h5 {
    font-weight: bold;
    color: #B11A1A;
  }
  
  h6 {
    line-height: 0;
    margin-top: 20px;
  }

  p {
    border: 1px solid #B8B6B6;
    border-radius: 3px;
    min-height: 43px;
    width: 100%;
    font-size: 28px;
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 5px;
  }

  .uci-h6 {
    width: 50px;
    margin-top: 20px;
  }

  .extra-h6 {
    line-height: 0;
    margin-top: 6px;
    margin-right: 40px;
  }

  .extra-p {
    border: 1px solid #B8B6B6;
    border-radius: 3px;
    min-height: 33px;
    width: 100%;
    margin-top: -10px;
    margin-bottom: 13px;
    font-size: 20px;
    font-weight: bold;
  }

  hr {
    margin-top: -5px;
  }

  @media only screen and (min-width: 1920px) {
    h5 {
      font-size: 32px;
      margin-bottom: 20px;
    }
    
    h6 {
     font-size: 18px;
     margin-bottom: 10px;
    }

    p {
      min-height: 72px;
      font-size: 46px;
    }   

    .uci-h6 {
      width: 50px;
      margin-top: 45px;
    }
    
    .extra-h6 {
      line-height: 0;
      font-size: 20px;
      margin-top: 20px;
      margin-right: 40px;
    }

    .extra-p {
      min-height: 50px;
      width: 100%;
      margin-top: -10px;
      font-size: 32px;
      font-weight: bold;
    }
  }
 
  @media only screen and (max-width: 768px) {
    h5 {
      font-size: 12px;
    }
    
    h6 {
     font-size: 12px;
    }

    p {
      min-height: 35px;
      font-size: 18px;
    }   
    
    .extra-h6 {
      font-size: 14px;
      margin-top: 5px;
      margin-right: 38px;
    }

    .extra-p {
      min-height: 32px;
      margin-top: -10px;
      font-size: 18px;
      font-weight: bold;
    }
  }
  
`